import { formatSpeakingClock, speakingClockTone } from '@/components/conclave/speaking-clock';
import { cn } from '@/lib/utils';

function ClockPill({
  label,
  seconds,
  totalSeconds,
}: {
  label: string;
  seconds: number;
  totalSeconds: number;
}) {
  const tone = speakingClockTone(seconds, totalSeconds);
  return (
    <div
      className={cn(
        'rounded-xl px-2.5 py-1 shadow-sm',
        tone === 'overtime' && 'bg-red-50 text-red-600',
        tone === 'warning' && 'bg-yellow-100 text-yellow-700',
        tone === 'ok' && 'bg-primary/10 text-primary'
      )}
    >
      <p className="text-[9px] font-bold uppercase tracking-widest">{label}</p>
      <p className="text-sm font-semibold tabular-nums leading-none">
        {formatSpeakingClock(seconds)}
      </p>
    </div>
  );
}

export function ConclaveSpeakingClock({
  sessionSeconds,
  sessionTotalSeconds = 0,
  userSeconds,
  userTotalSeconds = 0,
  className,
}: {
  sessionSeconds: number | null;
  sessionTotalSeconds?: number;
  userSeconds: number | null;
  userTotalSeconds?: number;
  className?: string;
}) {
  if (sessionSeconds == null && userSeconds == null) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {sessionSeconds != null ? (
        <ClockPill label="Session" seconds={sessionSeconds} totalSeconds={sessionTotalSeconds} />
      ) : null}
      {userSeconds != null ? (
        <ClockPill label="Speaker" seconds={userSeconds} totalSeconds={userTotalSeconds} />
      ) : null}
    </div>
  );
}
